import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLeadCycleData } from "../../../../redux/prospect-reducers/prospectSlice";
import PaginationBar from "../../lms-v2/lms-customised-comps/PaginationBar";
import { formatValueCycle, renderCycleDetails } from "../LMSMocks";

const LeadCycle = ({ userInfoData, rowData }) => {
  const dispatch = useDispatch();
  const { leadCycle, leadCycleLoading, leadCycleError } = useSelector(
    (state) => state.prospects
  );

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    lead_id: rowData?.lead_id,
  };
  const [filters, setFilters] = useState(iniFilters);

  const iniCycleData = {
    data: [],
    pagination: [],
  };
  const [cycleData, setCycleData] = useState(iniCycleData);

  const getGymCycle = async (filters) => {
    dispatch(
      fetchLeadCycleData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    if (filters.lead_id) {
      getGymCycle(filters);
    }
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    if (
      !leadCycleLoading &&
      !leadCycleError &&
      leadCycle?.status &&
      leadCycle?.data
    ) {
      setCycleData((prev) => ({
        ...prev,
        data: leadCycle.data,
        pagination: leadCycle?.pagination,
      }));
    } else {
      setCycleData(iniCycleData);
    }
  }, [leadCycleLoading, leadCycleError, leadCycle]);

  if (leadCycleLoading) {
    return (
      <div className="lead-v2-cycle-loading">
        <div className="lead-v2-loading-spinner"></div>
        <p>Loading cycle data...</p>
      </div>
    );
  }

  // if (leadCycleError) {
  //   return (
  //     <div className="lead-v2-cycle-error">
  //       <p>Error loading cycle data. Please try again.</p>
  //     </div>
  //   );
  // }

  if (!cycleData.data || cycleData.data.length === 0) {
    return (
      <div className="lead-v2-cycle-empty">
        <p>No cycle data available for this lead.</p>
      </div>
    );
  }

  console.log(cycleData.pagination?.[0]?.pages);

  return (
    <div className="lead-v2-cycle-container">
      <div className="lead-v2-cycle-header">
        <h5>Lead Conversion Cycle</h5>
        <span className="lead-v2-cycle-count">
          {cycleData.data.length} cycle{cycleData.data.length !== 1 ? "s" : ""}
        </span>
      </div>

      <div className="lead-v2-cycle-list mb30">
        {cycleData.data.map((cycle, index) => (
          <div key={index} className="lead-v2-cycle-card">
            <div className="lead-v2-cycle-card-header">
              <div className="lead-v2-cycle-status">
                <span
                  className={`lead-v2-cycle-status-badge ${
                    cycle.container_status || cycle.status
                  }`}
                >
                  {formatValueCycle(
                    "container_status",
                    cycle.container_status || cycle.status
                  )}
                </span>
              </div>
              <div className="lead-v2-cycle-meta">
                <span className="lead-v2-cycle-date">
                  {formatValueCycle("date_added", cycle.date_added)}
                </span>
                {cycle.converted_date && (
                  <span className="lead-v2-cycle-converted">
                    Converted:{" "}
                    {formatValueCycle("converted_date", cycle.converted_date)}
                  </span>
                )}
              </div>
            </div>

            <div className="lead-v2-cycle-card-body">
              <div className="lead-v2-cycle-summary">
                <div className="lead-v2-cycle-summary-item">
                  <span className="lead-v2-cycle-label">Lead Source:</span>
                  <span className="lead-v2-cycle-value">
                    {formatValueCycle("lead_source", cycle.lead_source)}
                  </span>
                </div>

                {cycle.converted_value ? (
                  <div className="lead-v2-cycle-summary-item">
                    <span className="lead-v2-cycle-label">
                      Converted Value:
                    </span>
                    <span className="lead-v2-cycle-value highlight">
                      {formatValueCycle(
                        "converted_value",
                        cycle.converted_value
                      )}
                    </span>
                  </div>
                ) : null}

                {cycle.lead_value ? (
                  <div className="lead-v2-cycle-summary-item">
                    <span className="lead-v2-cycle-label">Lead Value:</span>
                    <span className="lead-v2-cycle-value">
                      {formatValueCycle("lead_value", cycle.lead_value)}
                    </span>
                  </div>
                ) : null}

                <div className="lead-v2-cycle-summary-item">
                  <span className="lead-v2-cycle-label">Added By:</span>
                  <span className="lead-v2-cycle-value">
                    {cycle.added_by_name || "N/A"}
                  </span>
                </div>

                <div className="lead-v2-cycle-summary-item">
                  <span className="lead-v2-cycle-label">Assigned To:</span>
                  <span className="lead-v2-cycle-value">
                    {cycle.assigned_to_name || "N/A"}
                  </span>
                </div>
              </div>

              <div className="lead-v2-cycle-expandable">
                <details className="lead-v2-cycle-details-toggle">
                  <summary className="lead-v2-cycle-details-summary">
                    View Full Details
                  </summary>

                  {renderCycleDetails(cycle)}
                </details>
              </div>
            </div>
          </div>
        ))}
      </div>

      {Number(cycleData.pagination?.[0]?.pagination || 0) > 10 && (
        <PaginationBar
          isPage={isPage}
          setIsPage={setIsPage}
          paginationArray={cycleData.pagination}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </div>
  );
};

export default LeadCycle;
